<template>
    <draggable
        tag="ul"
        :list="categories"
        @change="handleChange"
        :group="{ name: 'categories' }"
        class="draggable-wrapper"
        :class="{ 'p-0': !parentId }"
        ref="draggable"
    >
        <li
            v-for="(item, index) in categories"
            v-show="openParent"
            :key="item.id"
            :class="{ 'my-3': index > 0 || parentId }"
        >
            <div class="d-flex align-items-center categories-item">
                <span
                    class="left-icon-wrapper d-flex align-items-center justify-content-between"
                >
                    <i class="fas fa-align-justify w-100 text-center"></i>
                </span>
                <span class="text-left ml-2 text-dark pt-1">
                    {{ item.content }} | {{ item.product_count }} product(s).
                </span>
                <span class="ml-auto align-center d-flex align-items-center">
                    <button
                        v-if="item.children"
                        class="badge badge-primary badge-pill mx-3"
                        @click="item.openChildren = !item.openChildren"
                    >
                        Nested categories
                        <i class="fas fa-chevron-down"></i>
                    </button>
                    <span class="mx-2" v-if="item.is_smart == 1">
                        <i class="fas fa-lightbulb-o"></i>
                    </span>
                    <span class="mx-2">
                        <i
                            v-if="item.is_visible == 1"
                            class="fas fa-eye fa-2x"
                        ></i>
                        <i v-else class="fas fa-eye-slash fa-2x"></i>
                    </span>
                    <a
                        class="btn btn-outline-primary btn-editable mr-2"
                        :href="'/categories/' + item.id + '/edit/'"
                    >
                        Edit
                    </a>
                </span>
            </div>
            <transition name="fade">
                <category-tree-item
                    v-if="item.children"
                    :open-parent="item.openChildren"
                    :categories="item.children"
                    :parent-id="item.id"
                ></category-tree-item>
            </transition>
        </li>
    </draggable>
</template>
<script>
import draggable from "vuedraggable";
import axios from "axios";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    props: {
        categories: {
            required: true,
            type: Array,
        },
        parentId: {
            required: false,
            type: [Number, String],
            default: null,
        },
        openParent: {
            required: false,
            type: Boolean,
        },
    },
    components: {
        draggable,
    },
    name: "category-tree-item",
    methods: {
        updateSortOrder(payload) {

            axios
                .put(
                    base_url +
                        "/categories/" +
                        payload.newParentId +
                        "/setsortorder",
                    payload
                )
                .then(
                    function (res) {
                        this.$emit("category-changed", {
                            message: "Category tree updated successfully",
                            status: "alert-success",
                        });
                    }.bind(this)
                )
                .catch(
                    function (err) {
                        this.$emit("category-changed", {
                            message: err.message,
                            status: "alert-danger",
                        });
                    }.bind(this)
                );
        },
        updateParentId(payload) {
            axios
                .put(
                    base_url +
                        "/pimapi/categories/" +
                        payload.categoryId +
                        "/setparentid",
                    payload
                )
                .then(
                    function (res) {
                        this.$emit("category-changed", {
                            message: "Category tree updated successfully",
                            status: "alert-success",
                        });
                    }.bind(this)
                )
                .catch(
                    function (err) {
                        this.$emit("category-changed", {
                            message: err.message,
                            status: "alert-danger",
                        });
                    }.bind(this)
                );
        },
        handleChange(event) {
            let sortOrder = this.$refs.draggable.realList.map(
                (item) => item.id
            );

            if (event.moved) {
                let newParentId = this.parentId;

                this.updateSortOrder({
                    sortOrder: sortOrder,
                    newParentId: newParentId,
                });
            }

            if (event.removed) {
                let newParentId = event.removed.element.parent_id;

                this.updateSortOrder({
                    sortOrder: sortOrder,
                    newParentId: newParentId,
                });
            }

            if (event.added) {
                let categoryId = event.added.element.id;
                let newParentId = this.parentId == null ? 1 : this.parentId;

                this.updateParentId({
                    categoryId: categoryId,
                    newParentId: newParentId,
                });

                this.updateSortOrder({
                    sortOrder: sortOrder,
                    newParentId: newParentId,
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.draggable-wrapper {
    list-style-type: none;
}
.left-icon-wrapper {
    cursor: grab;
    height: 48px;
    width: 48px;
    color: rgba(57, 81, 155, 0.6);
    background: #edeff4;
}
.badge {
    cursor: pointer;
    border-radius: 3px;
}
.categories-item {
    list-style-type: none;
    border: 1px solid #dedede;
    border-radius: 2px;
}
</style>
